import { render, staticRenderFns } from "./ProfessionalsCarousel.vue?vue&type=template&id=3bf09b9c&scoped=true"
import script from "./ProfessionalsCarousel.vue?vue&type=script&lang=js"
export * from "./ProfessionalsCarousel.vue?vue&type=script&lang=js"
import style0 from "./ProfessionalsCarousel.vue?vue&type=style&index=0&id=3bf09b9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf09b9c",
  null
  
)

export default component.exports